import { render, staticRenderFns } from "./ListAccessory.vue?vue&type=template&id=5f6a5151&scoped=true"
import script from "./ListAccessory.vue?vue&type=script&lang=js"
export * from "./ListAccessory.vue?vue&type=script&lang=js"
import style0 from "./ListAccessory.vue?vue&type=style&index=0&id=5f6a5151&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6a5151",
  null
  
)

export default component.exports